import { jsx as t, jsxs as p } from "react/jsx-runtime";
import { useId as _ } from "react";
import { c as j } from "../clsx-OuTLNxxd.js";
import { C as h } from "../Check-CPyIclk1.js";
const I = "_list_1vjat_1", d = "_listItem_1vjat_10", f = "_iconWrapper_1vjat_15", s = {
  list: I,
  listItem: d,
  iconWrapper: f,
  "size--s": "_size--s_1vjat_23",
  "size--m": "_size--m_1vjat_35"
}, N = ({
  className: l,
  direction: e,
  items: c,
  size: i = "m",
  ...r
}) => {
  const a = _(), o = e ? { flexDirection: e } : {};
  return /* @__PURE__ */ t(
    "ul",
    {
      className: j(s.list, s[`size--${i}`], l),
      style: o,
      ...r,
      children: c.map((m, n) => /* @__PURE__ */ p("li", { className: s.listItem, children: [
        /* @__PURE__ */ t("span", { className: s.iconWrapper, children: /* @__PURE__ */ t(h, { className: s.check, color: "blue", size: i }) }),
        /* @__PURE__ */ t("span", { children: m })
      ] }, `list-${a}-item-${n}`))
    }
  );
};
export {
  N as List
};
